(function () {
  'use strict';

  var root = document.querySelector('[data-te-chapter]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var stages = Array.prototype.slice.call(root.querySelectorAll('[data-ch-stage]'));
  var journey = root.querySelector('[data-ch-journey]');
  var journeyItems = root.querySelector('[data-ch-journey-items]');
  var percent = root.querySelector('[data-ch-percent]');
  var readFill = root.querySelector('[data-ch-readline-fill]');
  var signal = root.querySelector('[data-ch-signal]');
  var motionItems = Array.prototype.slice.call(root.querySelectorAll('.te-prose > *'));

  root.classList.add('ch-motion-ready');

  function setActive(index) {
    stages.forEach(function (stage, i) {
      stage.classList.toggle('is-current', i === index);
    });
    if (journeyItems) {
      journeyItems.querySelectorAll('button').forEach(function (button, i) {
        var active = i === index;
        button.classList.toggle('is-current', active);
        button.setAttribute('aria-current', active ? 'step' : 'false');
      });
    }
  }

  if (journey && journeyItems && stages.length) {
    stages.forEach(function (stage, index) {
      var title = stage.querySelector('.ch-h');
      var button = document.createElement('button');
      var label = title ? title.textContent.trim() : 'Section ' + (index + 1);
      button.type = 'button';
      button.className = 'ch-journey__step';
      button.setAttribute('aria-label', 'Go to section ' + (index + 1) + ': ' + label);
      button.innerHTML = '<span class="ch-journey__dot" aria-hidden="true"></span><span class="ch-journey__index">' + String(index + 1).padStart(2, '0') + '</span>';
      button.addEventListener('click', function () {
        stage.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
      journeyItems.appendChild(button);
    });
    journey.hidden = false;
    setActive(0);
  }

  motionItems.forEach(function (item, index) {
    item.classList.add('ch-motion-item');
    item.style.setProperty('--motion-index', index % 6);
  });

  root.querySelectorAll('.te-ledger__row').forEach(function (row, index) {
    row.style.setProperty('--row-index', index);
  });

  if (reduced || !('IntersectionObserver' in window)) {
    motionItems.forEach(function (item) { item.classList.add('is-alive'); });
    stages.forEach(function (stage) { stage.classList.add('is-alive'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-alive');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    motionItems.forEach(function (item) { revealObserver.observe(item); });

    var stageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(stages.indexOf(entry.target));
          entry.target.classList.add('is-alive');
        }
      });
    }, { threshold: 0, rootMargin: '-28% 0px -58% 0px' });
    stages.forEach(function (stage) { stageObserver.observe(stage); });
  }

  var ticking = false;
  function updateProgress() {
    var rect = root.getBoundingClientRect();
    var readable = Math.max(1, rect.height - window.innerHeight);
    var value = Math.min(1, Math.max(0, -rect.top / readable));
    if (readFill) readFill.style.transform = 'scaleX(' + value.toFixed(4) + ')';
    if (percent) percent.textContent = String(Math.round(value * 100)).padStart(2, '0') + '%';
    root.style.setProperty('--chapter-progress', value.toFixed(4));
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateProgress);
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('resize', updateProgress);
  updateProgress();

  if (signal && !reduced) {
    signal.addEventListener('pointermove', function (event) {
      var rect = signal.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width - 0.5;
      var y = (event.clientY - rect.top) / rect.height - 0.5;
      signal.style.setProperty('--signal-x', x.toFixed(3));
      signal.style.setProperty('--signal-y', y.toFixed(3));
    });
    signal.addEventListener('pointerleave', function () {
      signal.style.setProperty('--signal-x', '0');
      signal.style.setProperty('--signal-y', '0');
    });
  }

  root.querySelectorAll('.ch-ref__opt').forEach(function (option) {
    option.addEventListener('click', function () {
      option.classList.remove('is-pulsing');
      requestAnimationFrame(function () { option.classList.add('is-pulsing'); });
      window.setTimeout(function () { option.classList.remove('is-pulsing'); }, 720);
    });
  });
})();
